import React, { useEffect, useState } from 'react';
import { JSON_ONE } from "./JSON_DATA_Request";
import { JSON_ONE1 } from "./JSON_DATA_Response";
import { JSON_ONE11} from "./JSON_DATA_Requestflowone";
import { JSON_ONE41 } from "./JSON_DATA_Responseflowtwo";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ResponseJSON from './ResponseJSON';
import RequestJSON from './RequestJSON';
import RequestJSONflowone from './RequestJSONflowone';
import ResponseJSONflowtwo from './ResponseJSONflowtwo';
function IntegrationAPIforMerchantOnboarding() {
const [ShowHideAccordionOne, SetShowHideAccordionOne] = useState(false);
const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
const onClickAccordianShowHideOne = () => {
SetShowHideAccordionOne(!ShowHideAccordionOne)
}
const onClickAccordianShowHideTwo = () => {
SetShowHideAccordionTwo(!ShowHideAccordionTwo)
}
const [TabCheck, SetTabCheck] = useState(false)
const [TabCheck1, SetTabCheck1] = useState(false)
const [TabCheck2, SetTabCheck2] = useState(false)
const onClickCangeTab = () => {
SetTabCheck(!TabCheck);
}
const onClickCangeTab1 = () => {
SetTabCheck1(!TabCheck1);
}
const onClickCangeTab2 = () => {
SetTabCheck2(!TabCheck2);
}
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_layout1">
               <h1>Integration API for Merchant On boarding</h1>
               <hr/>
            </section>
         </div>
         <div class="col-md-4 extreme-rt-div">
         </div>
      </div>
      <div class="row">
         <div class="col-md-8 mt-60">
            <h2 id="merchant-online-onboard-sec">Merchant Online Onboarding API</h2>
            <p>
               This API onboard the merchant directly on Safexpay.
            </p>
            <h6 className='col-gray'><u>AUTHORIZATIONS:</u></h6>
            <h6 className="mt-10 col-gray">REQUEST BODY SCHEMA:  application-json</h6>
            <hr class="hr-col">
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Aggregator id.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="user_id"><span class="sc-iemWCZ fhDkLh"></span><span>user_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr className='expanded'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideOne}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           mer-bussiness-details {ShowHideAccordionOne ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordionOne &&
                  <tr>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bussiness_description"><span class="sc-iemWCZ fhDkLh"></span><span>bussiness_description</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div>
                                             <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                          </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="office_address"><span class="sc-iemWCZ fhDkLh"></span><span>office_address</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="country_code">
                                       <span class="sc-iemWCZ fhDkLh"></span><span>country_code</span>
                                    </td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                             <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                          </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="state"><span class="sc-iemWCZ fhDkLh"></span><span>state</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div>
                                             <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                          </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="city"><span class="sc-iemWCZ fhDkLh"></span><span>city</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div>
                                             <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                          </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pincode"><span class="sc-iemWCZ fhDkLh"></span><span>pincode</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="category_id"><span class="sc-iemWCZ fhDkLh"></span><span>category_id</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                             <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                          </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="sub_category">
                                       <span class="sc-iemWCZ fhDkLh"></span><span>sub_category</span>
                                    </td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="director_name"><span class="sc-iemWCZ fhDkLh"></span><span>director_name</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pan_number"><span class="sc-iemWCZ fhDkLh"></span><span>pan_number</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="director_email"><span class="sc-iemWCZ fhDkLh"></span><span>director_email</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="company_phone"><span class="sc-iemWCZ fhDkLh"></span><span>company_phone</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="director_phone"><span class="sc-iemWCZ fhDkLh"></span><span>director_phone</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="turnover"><span class="sc-iemWCZ fhDkLh"></span><span>turnover</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="average_ticket_size"><span class="sc-iemWCZ fhDkLh"></span><span>average_ticket_size</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
                  <tr className='expanded last undefined'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideTwo}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           mer-bank-details {ShowHideAccordionTwo ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordionTwo &&
                  <tr className='expanded last undefined'>
                     <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bank_id"><span class="sc-iemWCZ fhDkLh"></span>
                                       <span>bank_id</span>
                                    </td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="account_type"><span class="sc-iemWCZ fhDkLh"></span><span>account_type</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="account_number"><span class="sc-iemWCZ fhDkLh"></span><span>account_number</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                             <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                          </div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="account_holder_name">
                                       <span class="sc-iemWCZ fhDkLh"></span><span>account_holder_name</span>
                                    </td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="settlement_currency"><span class="sc-iemWCZ fhDkLh"></span><span>settlement_currency</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ifsc_code"><span class="sc-iemWCZ fhDkLh"></span><span>ifsc_code</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bank_city"><span class="sc-iemWCZ fhDkLh"></span><span>bank_city</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
               </tbody>
            </table>
            <h5 className="mt-30">Responses</h5>
            <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
               <div class="card">
                  <div class="card-header" id="heading1">
                     <h5 class="mb-0">
                        <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                        <b>200</b>  {TabCheck1 ?
                        <FaAngleUp />
                        :
                        <FaAngleDown />
                        }
                  </div>
                  </h5>
               </div>
               {
               TabCheck1 &&
               <div>
                  <div class="card-body">
                     <h6 class="mt-10"><span>RESPONSE SCHEMA: </span> <span style={{ color: "#313131" }}>application/json</span></h6>
                     <hr class="hr-col">
                     </hr>
                     <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="id"><span class="sc-iemWCZ fhDkLh"></span><span>id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="account_holder_name"><span class="sc-iemWCZ fhDkLh"></span><span>account_holder_name</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="account_number"><span class="sc-iemWCZ fhDkLh"></span><span>account_number</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="account_type"><span class="sc-iemWCZ fhDkLh"></span><span>account_type</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="average_ticket_size"><span class="sc-iemWCZ fhDkLh"></span><span>average_ticket_size</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bank_city"><span class="sc-iemWCZ fhDkLh"></span><span>bank_city</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bank_id"><span class="sc-iemWCZ fhDkLh"></span><span>bank_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bussiness_description">
                                 <span class="sc-iemWCZ fhDkLh"></span><span>bussiness_description</span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="category_id"><span class="sc-iemWCZ fhDkLh"></span><span>category_id</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="city"><span class="sc-iemWCZ fhDkLh"></span><span>city</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="company_phone"><span class="sc-iemWCZ fhDkLh"></span><span>company_phone</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="country_code"><span class="sc-iemWCZ fhDkLh"></span><span>country_code</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Ind</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="createdBy"><span class="sc-iemWCZ fhDkLh"></span><span>createdBy</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="creationDate"><span class="sc-iemWCZ fhDkLh"></span>
                                 <span>creationDate</span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="director_email"><span class="sc-iemWCZ fhDkLh"></span>
                                 <span>director_email</span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="director_name"><span class="sc-iemWCZ fhDkLh"></span><span>director_name</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                       <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="director_phone"><span class="sc-iemWCZ fhDkLh"></span><span>director_phone</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                       <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="document_urls"><span class="sc-iemWCZ fhDkLh"></span><span>document_urls</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                       <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> 
                                       <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 200 </span></span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="email_id">
                                 <span class="sc-iemWCZ fhDkLh"></span><span>email_id</span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="first_name"><span class="sc-iemWCZ fhDkLh"></span><span>first_name</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ifsc_code"><span class="sc-iemWCZ fhDkLh"></span><span>ifsc_code</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                       <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="is_paid"><span class="sc-iemWCZ fhDkLh"></span><span>is_paid</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                       <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="last_name"><span class="sc-iemWCZ fhDkLh"></span><span>last_name</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchant_name"><span class="sc-iemWCZ fhDkLh"></span><span>merchant_name</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meId"><span class="sc-iemWCZ fhDkLh"></span><span>meId</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div>
                                       <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="mobile_no"><span class="sc-iemWCZ fhDkLh"></span><span>mobile_no</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="modificationDate">
                                 <span class="sc-iemWCZ fhDkLh"></span><span>modificationDate</span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="modifiedBy"><span class="sc-iemWCZ fhDkLh"></span><span>modifiedBy</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="office_address"><span class="sc-iemWCZ fhDkLh"></span><span>office_address</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pan_number"><span class="sc-iemWCZ fhDkLh"></span><span>pan_number</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="password"><span class="sc-iemWCZ fhDkLh"></span><span>password</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pincode"><span class="sc-iemWCZ fhDkLh"></span><span>pincode</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>323223</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pricing_plan"><span class="sc-iemWCZ fhDkLh"></span><span>pricing_plan</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="settlement_currency"><span class="sc-iemWCZ fhDkLh"></span><span>settlement_currency</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="state"><span class="sc-iemWCZ fhDkLh"></span><span>state</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status">
                                 <span class="sc-iemWCZ fhDkLh"></span><span>status</span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="sub_category"><span class="sc-iemWCZ fhDkLh"></span>
                                 <span>sub_category</span>
                              </td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="turnover"><span class="sc-iemWCZ fhDkLh"></span><span>turnover</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="website_url"><span class="sc-iemWCZ fhDkLh"></span><span>website_url</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="message"><span class="sc-iemWCZ fhDkLh"></span><span>message</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reId"><span class="sc-iemWCZ fhDkLh"></span><span>reId</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="statusCode"><span class="sc-iemWCZ fhDkLh"></span><span>statusCode</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="legal_name"><span class="sc-iemWCZ fhDkLh"></span><span>legal_name</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                       <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                                    </div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="legal_office_address"><span class="sc-iemWCZ fhDkLh"></span><span>legal_office_address</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="company_name"><span class="sc-iemWCZ fhDkLh"></span><span>company_name</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="indianCustomer"><span class="sc-iemWCZ fhDkLh"></span><span>indianCustomer</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="iAgree"><span class="sc-iemWCZ fhDkLh"></span><span>iAgree</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr class="last undefined">
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="businessType"><span class="sc-iemWCZ fhDkLh"></span><span>businessType</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
               }
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>400 Bad request</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>403 forbidden</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>404 Not found</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>500 server-error</span> </h5>
               </div>
            </div>
            <div class="card mb-60">
               <div class="card-header">
                  <h5 class="mb-0"> <span>503 service-unavailable</span> </h5>
               </div>
            </div>
         </div>
      </div>
      <div class="col-md-4 extreme-rt-div">
         <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
            <div class="card">
               <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                     <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab}>
                     <button> POST </button> /api/merchantOnline Boarding/post {TabCheck ?
                     <FaAngleUp />
                     :
                     <FaAngleDown />
                     }
               </div>
               </h5>
            </div>
            {
            TabCheck &&
            <div>
               <br />
               <div class="card-body">
                  <p class="mb-0">Production server (uses live data)</p>
                  <div class="api-div-bor">
                     <span>https://www.avantgardepayments.com</span><span
                        class="col-org">/agcore/api/merchantOnlineBoarding/post</span>
                  </div>
                  <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                  <div class="api-div-bor">
                     <span>https://pguat.safexpay.com</span><span
                        class="col-org">/agcore/api/merchantOnlineBoarding/post</span>
                  </div>
               </div>
            </div>
            }
         </div>
      </div>
      <RequestJSON/>
      <ResponseJSON/>
   </div>
</div>
<hr class="hr-seperator"></hr>
<div class="row">
   <div class="col-md-8 mt-60">
      <h2 id="status-api-sec">Status API</h2>
      <p>
         This API is used to get the updated response from the safexpay server about the onboarding/verification status.
      </p>
      <h5>Response Parameter:</h5>
      <ul>
         <li>This API response will be in Encrypted Format, merchant needs to decrypt the data using merchant key.<br/>
            0TFmSCWfC6wd3jYIvt/g2zqv+ot8iWua/dwbHsgO/dE=
         </li>
         <li>Response Message you will get after the Decryption based on the application approval from the Safexpay end.</li>
      </ul>
      <ol>
         <li>Verification Pending.</li>
         <li>Verification Done.</li>
         <li>Verification Pending, please contact Your Admin.</li>
         <li>Remark, if Rejected.</li>
      </ol>
      <h6 className='col-gray'><u>AUTHORIZATIONS:</u></h6>
      <h6 className="mt-10 col-gray">REQUEST BODY SCHEMA:  application-json</h6>
      <hr class="hr-col">
      </hr>
      <table class="sc-hHEiqL iZJLLY">
         <tbody>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="re_id"><span class="sc-iemWCZ fhDkLh"></span><span>re_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Reseller id.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr class="last undefined">
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                     </div>
                  </div>
               </td>
            </tr>
         </tbody>
      </table>
      <h5 className="mt-30">Responses</h5>
      <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1">
               <h5 class="mb-0" style={{ backgroundColor: "rgb(239 246 240)", color: "rgb(29, 129, 39)"}}> <span>200 Success response</span> </h5>
            </div>
         </div>
         <div class="card">
            <div class="card-header" id="heading1">
               <h5 class="mb-0"> <span>400 Bad request</span> </h5>
            </div>
         </div>
         <div class="card">
            <div class="card-header">
               <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
            </div>
         </div>
         <div class="card">
            <div class="card-header">
               <h5 class="mb-0"> <span>403 forbidden</span> </h5>
            </div>
         </div>
         <div class="card">
            <div class="card-header">
               <h5 class="mb-0"> <span>404 Not found</span> </h5>
            </div>
         </div>
         <div class="card">
            <div class="card-header">
               <h5 class="mb-0"> <span>500 server-error</span> </h5>
            </div>
         </div>
         <div class="card mb-60">
            <div class="card-header">
               <h5 class="mb-0"> <span>503 service-unavailable</span> </h5>
            </div>
         </div>
      </div>
   </div>
   <div class="col-md-4 extreme-rt-div">
      <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1">
               <h5 class="mb-0">
                  <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab}>
                  <button> POST </button> /sdk/getMerchant StatusByReId {TabCheck ?
                  <FaAngleUp />
                  :
                  <FaAngleDown />
                  }
            </div>
            </h5>
         </div>
         {
         TabCheck &&
         <div>
            <br />
            <div class="card-body">
               <p class="mb-0">Production server (uses live data)</p>
               <div class="api-div-bor">
                  <span>https://www.avantgardepayments.com</span><span
                     class="col-org">/agmerchant/sdk/getMerchantStatusByReId</span>
               </div>
               <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
               <div class="api-div-bor">
                  <span>https://pguat.safexpay.com</span><span
                     class="col-org">/agmerchant/sdk/getMerchantStatusByReId</span>
               </div>
            </div>
         </div>
         }
      </div>
   </div>
   <RequestJSONflowone/>
</div>
</div>
<hr class="hr-seperator"></hr>
<div class="row">
   <div class="col-md-8 mt-60">
      <h2 id="document-kyc-upload-sec">Document/KYC Upload API</h2>
      <p>This API is used to upload the KYC Documents.</p>
      <ul>
         <li>Request Parameters: The Parameters should be pass in form-data for this API, screen below.</li>
         <li>If Documents are uploaded for the first time, then the type should be “create”.</li>
         <li>If Documents are uploaded when rejected , then type should be “update”.</li>
      </ul>
      <h5>Request for Create</h5>
      <p>
         ag_id=paygate<br/>
         user_id=anuja3360<br/>
         kycDocuments=//select a file<br/>
         nonKycDocuments=//select a file<br/>
         type=create<br/>
      </p>
      <h5>Request for Update</h5>
      <p>
         ag_id=paygate<br/>
         user_id=anuja3360<br/>
         kycDocuments=//select a file<br/>
         nonKycDocuments=//select a file<br/>
         type=update<br/>
      </p>
      <h5>Response:</h5>
      <ul>
         <li>If Merchant is created, then the response should be “Successful”.</li>
         <li>Note : Maximum file size for uploading the KYC document is of 2 MB</li>
      </ul>
      <h6><u>AUTHORIZATIONS:</u></h6>
      <h6 className="mt-10">REQUEST BODY SCHEMA:  multipart/form-data</h6>
      <hr class="hr-col">
      </hr>
      <table class="sc-hHEiqL iZJLLY">
         <tbody>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="user_id"><span class="sc-iemWCZ fhDkLh"></span><span>user_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="kycDocuments"><span class="sc-iemWCZ fhDkLh"></span><span>kycDocuments</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">file</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="nonKycDocuments"><span class="sc-iemWCZ fhDkLh"></span><span>nonKycDocuments</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">file</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr class="last undefined">
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="type"><span class="sc-iemWCZ fhDkLh"></span><span>type</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                     </div>
                  </div>
               </td>
            </tr>
         </tbody>
      </table>
      <h5 className="mt-30">Responses</h5>
      <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1">
               <h5 class="mb-0">
                  <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                  <b>200</b> Success response  {TabCheck1 ?
                  <FaAngleUp />
                  :
                  <FaAngleDown />
                  }
            </div>
            </h5>
         </div>
         {
         TabCheck1 &&
         <div>
            <div class="card-body">
               <h6 class="mt-10"><span>RESPONSE SCHEMA: </span> <span style={{ color: "#313131" }}>application/json</span></h6>
               <hr class="hr-col">
               </hr>
               <table class="sc-hHEiqL iZJLLY">
                  <tbody>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="id"><span class="sc-iemWCZ fhDkLh"></span><span>id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="account_holder_name"><span class="sc-iemWCZ fhDkLh"></span><span>account_holder_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="account_number"><span class="sc-iemWCZ fhDkLh"></span><span>account_number</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="account_type"><span class="sc-iemWCZ fhDkLh"></span><span>account_type</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="average_ticket_size"><span class="sc-iemWCZ fhDkLh"></span><span>average_ticket_size</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bank_city"><span class="sc-iemWCZ fhDkLh"></span><span>bank_city</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bank_id"><span class="sc-iemWCZ fhDkLh"></span><span>bank_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bussiness_description">
                           <span class="sc-iemWCZ fhDkLh"></span><span>bussiness_description</span>
                        </td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="category_id"><span class="sc-iemWCZ fhDkLh"></span>
                           <span>category_id</span>
                        </td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="city"><span class="sc-iemWCZ fhDkLh"></span><span>city</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                 <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                              </div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="company_phone"><span class="sc-iemWCZ fhDkLh"></span><span>company_phone</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="country_code"><span class="sc-iemWCZ fhDkLh"></span><span>country_code</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="createdBy"><span class="sc-iemWCZ fhDkLh"></span><span>createdBy</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="creationDate"><span class="sc-iemWCZ fhDkLh"></span><span>creationDate</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div>
                                 <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                              </div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="director_email"><span class="sc-iemWCZ fhDkLh"></span><span>director_email</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="director_name"><span class="sc-iemWCZ fhDkLh"></span><span>director_name</span>
                        </td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="director_phone"><span class="sc-iemWCZ fhDkLh"></span><span>director_phone</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="document_urls">
                           <span class="sc-iemWCZ fhDkLh"></span><span>document_urls</span>
                        </td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="email_id"><span class="sc-iemWCZ fhDkLh"></span><span>email_id</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="first_name"><span class="sc-iemWCZ fhDkLh"></span><span>first_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ifsc_code"><span class="sc-iemWCZ fhDkLh"></span><span>ifsc_code</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="is_paid"><span class="sc-iemWCZ fhDkLh"></span><span>is_paid</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="last_name"><span class="sc-iemWCZ fhDkLh"></span><span>last_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchant_name"><span class="sc-iemWCZ fhDkLh"></span><span>merchant_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meId"><span class="sc-iemWCZ fhDkLh"></span><span>meId</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="mobile_no"><span class="sc-iemWCZ fhDkLh"></span><span>mobile_no</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="modificationDate"><span class="sc-iemWCZ fhDkLh"></span><span>modificationDate</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="modifiedBy"><span class="sc-iemWCZ fhDkLh"></span><span>modifiedBy</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="office_address"><span class="sc-iemWCZ fhDkLh"></span>
                           <span>office_address</span>
                        </td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pan_number"><span class="sc-iemWCZ fhDkLh"></span><span>pan_number</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="password"><span class="sc-iemWCZ fhDkLh"></span><span>password</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pincode"><span class="sc-iemWCZ fhDkLh"></span><span>pincode</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pricing_plan"><span class="sc-iemWCZ fhDkLh"></span><span>pricing_plan</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="settlement_currency"><span class="sc-iemWCZ fhDkLh"></span><span>settlement_currency</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="state">
                           <span class="sc-iemWCZ fhDkLh"></span><span>state</span>
                        </td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="sub_category"><span class="sc-iemWCZ fhDkLh"></span><span>sub_category</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="turnover"><span class="sc-iemWCZ fhDkLh"></span><span>turnover</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="website_url"><span class="sc-iemWCZ fhDkLh"></span><span>website_url</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="message"><span class="sc-iemWCZ fhDkLh"></span><span>message</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="reId"><span class="sc-iemWCZ fhDkLh"></span><span>reId</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="statusCode"><span class="sc-iemWCZ fhDkLh"></span><span>statusCode</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="legal_name"><span class="sc-iemWCZ fhDkLh"></span><span>legal_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="legal_office_address">
                           <span class="sc-iemWCZ fhDkLh"></span><span>legal_office_address</span>
                        </td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="company_name"><span class="sc-iemWCZ fhDkLh"></span><span>company_name</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="indianCustomer"><span class="sc-iemWCZ fhDkLh"></span><span>indianCustomer</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="iAgree"><span class="sc-iemWCZ fhDkLh"></span><span>iAgree</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                              </div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                     <tr class="last undefined">
                        <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="businessType"><span class="sc-iemWCZ fhDkLh"></span><span>businessType</span></td>
                        <td class="sc-bkbkJK gmOLLi">
                           <div>
                              <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                              <div>
                                 <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                              </div>
                           </div>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         }
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>400 Bad request</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>403 forbidden</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>404 Not found</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>500 server-error</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span>503 service-unavailable</span> </h5>
         </div>
      </div>
   </div>
</div>
<div class="col-md-4 extreme-rt-div">
   <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
      <div class="card">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab}>
               <button> POST </button> /api/merchantOnline BoardingDocumentUpload/post {TabCheck ?
               <FaAngleUp />
               :
               <FaAngleDown />
               }
         </div>
         </h5>
      </div>
      {
      TabCheck &&
      <div>
         <br />
         <div class="card-body">
            <p class="mb-0">Production server (uses live data)</p>
            <div class="api-div-bor">
               <span>https://www.avantgardepayments.com</span><span
                  class="col-org">/agmerchant/api/merchantOnlineBoardingDocumentUpload/post</span>
            </div>
            <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
            <div class="api-div-bor">
               <span>https://pguat.safexpay.com</span><span
                  class="col-org">/agmerchant/api/merchantOnlineBoardingDocumentUpload/post</span>
            </div>
         </div>
      </div>
      }
   </div>
</div>
<ResponseJSONflowtwo/>
</div>
</div>
</div>
</div>
)
}
export default IntegrationAPIforMerchantOnboarding